import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { Input } from "@faire/web/slate/Input";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Toggle } from "@faire/web/slate/Toggle";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";
export var ConfigurableOptions = function ConfigurableOptions(_ref) {
  var _searchOptions$isCase, _searchOptions$should, _searchOptions$includ, _searchOptions$includ2, _searchOptions$findAl, _searchOptions$useExt;
  var searchOptions = _ref.searchOptions,
    setSearchOptions = _ref.setSearchOptions;
  return /*#__PURE__*/React.createElement(ConfigurableOptionsWrapper, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansMedium"
  }, "Search Configuration"), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: "https://www.fusejs.io/api/options.html#options",
    target: "__blank"
  }, "Trying to understand these options?")), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, null, "keys: ", JSON.stringify(searchOptions.keys))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, "isCaseSensitive: "), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        isCaseSensitive: !searchOptions.isCaseSensitive
      }));
    },
    value: (_searchOptions$isCase = searchOptions.isCaseSensitive) !== null && _searchOptions$isCase !== void 0 ? _searchOptions$isCase : false
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, "shouldSort: "), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        shouldSort: !searchOptions.shouldSort
      }));
    },
    value: (_searchOptions$should = searchOptions.shouldSort) !== null && _searchOptions$should !== void 0 ? _searchOptions$should : false
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, "includeMatches: "), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        includeMatches: !searchOptions.includeMatches
      }));
    },
    value: (_searchOptions$includ = searchOptions.includeMatches) !== null && _searchOptions$includ !== void 0 ? _searchOptions$includ : false
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, "includeScore: "), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        includeScore: !searchOptions.includeScore
      }));
    },
    value: (_searchOptions$includ2 = searchOptions.includeScore) !== null && _searchOptions$includ2 !== void 0 ? _searchOptions$includ2 : false
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, "findAllMatches: "), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        findAllMatches: !searchOptions.findAllMatches
      }));
    },
    value: (_searchOptions$findAl = searchOptions.findAllMatches) !== null && _searchOptions$findAl !== void 0 ? _searchOptions$findAl : false
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical
  }, "useExtendedSearch: "), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Toggle, {
    onChange: function onChange() {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        useExtendedSearch: !searchOptions.useExtendedSearch
      }));
    },
    value: (_searchOptions$useExt = searchOptions.useExtendedSearch) !== null && _searchOptions$useExt !== void 0 ? _searchOptions$useExt : false
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Input, {
    label: "minMatchCharLength",
    placeholder: "1",
    value: searchOptions.minMatchCharLength,
    onChange: function onChange(e) {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        minMatchCharLength: Number(e.target.value)
      }));
    }
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(Input, {
    label: "location",
    placeholder: "0",
    value: searchOptions.location,
    onChange: function onChange(e) {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        location: Number(e.target.value)
      }));
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Input, {
    type: "number",
    label: "threshold",
    placeholder: "0.6",
    value: searchOptions.threshold,
    onChange: function onChange(e) {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        threshold: parseFloat(e.target.value)
      }));
    }
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), /*#__PURE__*/React.createElement(Input, {
    label: "distance",
    placeholder: "100",
    value: searchOptions.distance,
    onChange: function onChange(e) {
      return setSearchOptions(_objectSpread(_objectSpread({}, searchOptions), {}, {
        distance: Number(e.target.value)
      }));
    }
  })));
};
var ConfigurableOptionsWrapper = styled(Column).attrs({
  justify: "center"
}).withConfig({
  displayName: "ConfigurableOptions__ConfigurableOptionsWrapper"
})(["border:1px solid ", ";padding:", ";text-wrap:wrap;"], Core.border.info, getSpacing("2x"));